/* eslint-disable import/max-dependencies */
/* eslint-disable max-lines */
import React, { useEffect, useState } from 'react';
import {
  LineDetails,
  useGetHeaderText,
} from 'src/views/vendorprogram/hooks/deal-details';
import { useSearchParams } from 'react-router-dom';
import {
  ImSkuList,
  useDeleteIMSKU,
  useGetImSkuList,
  useSaveIMSKU,
  useDefaultSKU,
} from '../hooks/exceptionDeal';
import { useAlert } from 'src/hooks/useAlert';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/system';
import DrawerWrapper from 'src/components/Drawer/DrawerWrapper';
import { StyledText } from '../../../components/StyledTypography';
import IconButton from '@mui/material/IconButton';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import DialogComponent from '../components/DealDetailsPage/DialogComponent';
import SearchBarComp from 'src/components/SearchBar/SearchBar';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { useTranslate } from '@im/react-localization';
import DefaultDialog from '../components/DefaultDialog';
import { SyncIcon } from '../VendorProgramDetail/AutoquoteTab/components/TemplateEditor/IconPack';
import {
  useRefreshImSkuForRulesEngine,
  useRefreshImSku,
} from '../components/DealDetailsPage/DealDetailsPageTable/api';
import Tooltip from '@mui/material/Tooltip/Tooltip';
import useSnackBar from 'src/hooks/useSnackBar';

export default function EditImSKUDrawer(
  props: Readonly<{
    dealnumber: string;
    dealversion: number;
    enableRulesEngine: boolean;
    handleClose: () => void;
    isXcmVendor: boolean;
    productLocalizationForWeb: string;
    rowData: LineDetails;
    vendorProgramId: number;
  }>
) {
  const showAlert = useAlert();
  const { showSnackBar } = useSnackBar();
  const theme = useTheme();
  const translate = useTranslate();
  const [searchParams] = useSearchParams();
  const [inputValue, setInputValue] = useState<string>('');
  const [defaultWarning, setDefaultWarning] = useState<number | null>(null);
  const [makeDefault, setMakeDefault] = useState<boolean>(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState<boolean>(false);
  const [deleteSkuRequest, setDeleteSkuRequest] = useState<{
    imSku: string;
    skSboProductset: number;
  }>({
    imSku: '',
    skSboProductset: 0,
  });
  const [checked, setChecked] = useState<boolean>(false);
  const companyCode = searchParams.get('companyCode');
  const importreferenceid = searchParams.get('importreferenceid');
  const rowData = props.rowData;
  const defaultSKU = useDefaultSKU({
    sk_sbo_group: props.vendorProgramId,
    sku_no: inputValue,
    vendor_number: String(props.rowData.vendor_id),
    vpn: props.rowData.vpn,
  });
  const updateLine = useSaveIMSKU(
    {
      dealnumber: props.dealnumber,
      dealversion: props.dealversion,
      newImSku: inputValue,
      oldImSku: String(rowData?.im_sku),
      skSbo: Number(rowData?.deal_id),
      trackingID: Number(rowData?.dd_tracking),
    },
    String(importreferenceid)
  );
  const deleteImSku = useDeleteIMSKU(
    {
      ...deleteSkuRequest,
      dealnumber: props.dealnumber,
      dealversion: props.dealversion,
      isDeleteAll: checked,
      skSbo: Number(rowData?.deal_id),
      trackingID: Number(rowData?.dd_tracking),
    },
    importreferenceid
  );
  const isRulesEngineEnabled = props.enableRulesEngine;
  const xcmVendor = props.isXcmVendor;
  useEffect(() => {
    if (rowData?.im_sku && rowData.im_sku !== '')
      setInputValue(String(rowData?.im_sku));
    else setInputValue('');
  }, [rowData]);
  const checkDefaultSKU = () => {
    defaultSKU
      .mutateAsync(false)
      .then(
        (res) =>
          [400, 409].includes(res.statusCode) &&
          setDefaultWarning(res.statusCode)
      )
      .catch(() => undefined);
  };
  useEffect(() => {
    makeDefault && checkDefaultSKU();
  }, [makeDefault]); // eslint-disable-line react-hooks/exhaustive-deps
  const onSaveClick = () => {
    (makeDefault ? defaultSKU.mutateAsync(makeDefault) : Promise.resolve())
      .then(() => {
        updateLine
          .mutateAsync()
          .then((response) => {
            props.handleClose();
            showAlert({
              text: translate('ExceptionDeals.UpdateIMSKUSuccess', {
                value: response.transactionID,
              }),
              type: 'success',
            });
          })
          .catch((error) => {
            showAlert({ text: error.response?.message, type: 'error' });
            props.handleClose();
          });
      })
      .catch((error) => {
        showAlert({ text: error.response.message, type: 'error' });
      });
  };
  const imSkuList = useGetImSkuList({
    DiscountDetailId: Number(rowData?.discount_detail_id),
    EnableRulesEngine: isRulesEngineEnabled,
    IsXcmVendor: xcmVendor,
    SkSbo: Number(rowData?.deal_id),
    TrackingID: Number(rowData?.dd_tracking),
  });
  const handleOnChange = (option: any) => {
    if (option.id === 0) setInputValue('');
    else setInputValue(option.imsku);
  };
  const options = imSkuList?.data?.listGetImSku.filter(
    (sku) => sku.imsku != null && sku.imsku !== ''
  ).length
    ? imSkuList.data.listGetImSku.filter(
        (sku) => sku.imsku != null && sku.imsku !== ''
      )
    : [{ id: 0, imsku: translate('ExceptionDeals.IMSKUNotAvailable') }];

  const getOptionLabel = (option: ImSkuList) => {
    if (option.id === 0) return '';
    else return typeof option === 'string' ? option : option.imsku;
  };
  const renderOption = (option: ImSkuList) => {
    const imSkuListLength = imSkuList.data?.listGetImSku.length ?? 0;
    return (
      <Stack
        alignItems={'center'}
        direction={'row'}
        justifyContent={'space-between'}
        width={'100%'}
      >
        <StyledText>{option.imsku}</StyledText>
        {option.id !== 0 && imSkuListLength > 1 && (
          <IconButton
            onClick={() => {
              setOpenDeleteDialog(true);
              setDeleteSkuRequest({
                imSku: option.imsku,
                skSboProductset: option.id,
              });
            }}
          >
            <DeleteOutlinedIcon fontSize="small" />
          </IconButton>
        )}
      </Stack>
    );
  };
  const handleOverrideDefaultConfirmation = (result: boolean) => {
    setDefaultWarning(null);
    setMakeDefault(result);
  };

  const refreshSkuForRulesEngine = useRefreshImSkuForRulesEngine(
    Number(importreferenceid),
    {
      bidNumber: props.dealnumber,
      productLines: [
        {
          additionalAttributes: rowData.additional_attributes,
          discountDetailId: rowData.discount_detail_id,
          discountTrackingId: rowData.dd_tracking,
          productBusinessType: rowData.product_business_type,
          productSetType: rowData.productset_type,
          sbo2ProductSetId: String(rowData.sbo2_product_set_Id),
          vpn: rowData.vpn,
        },
      ],
      productLocalizationForWeb: props.productLocalizationForWeb,
      skSbo: String(rowData.deal_id),
      vendor: rowData.vendor_name,
      vendorProgramId: String(rowData.vendor_id),
      vendorProgramName: rowData.vendor_name,
    }
  );

  const refreshIMSku = useRefreshImSku(
    {
      company: companyCode ?? '',
      isXcmVendor: xcmVendor,
      lineItems: [
        {
          trackingNumber: String(rowData.dd_tracking),
          vendorCode: String(rowData.vendor_number),
          vpn: String(rowData.vpn),
        },
      ],
    },
    Number(importreferenceid)
  );

  const handleRefreshImSku = async () => {
    if (isRulesEngineEnabled) {
      props.handleClose();
      refreshSkuForRulesEngine
        .mutateAsync()
        .then(() => {
          showSnackBar({
            autoHide: 2000,
            message: translate(
              'VendorProgram.RefreshImSkuForRulesEngineSuccess'
            ),
            severity: 'success',
          });
        })
        .catch((error) => {
          showSnackBar({
            autoHide: 2000,
            message: isRulesEngineEnabled
              ? translate('VendorProgram.RefreshImSkuForRulesEngineFailure')
              : translate('VendorProgram.RefreshImSkuFailure'),
            severity: 'error',
          });
        });
    } else {
      refreshIMSku
        .mutateAsync()
        .then(() => {
          showSnackBar({
            autoHide: 2000,
            message: translate('VendorProgram.RefreshImSkuSuccess'),
            severity: 'success',
          });
        })
        .catch((error) => {
          showSnackBar({
            autoHide: 2000,
            message: translate('VendorProgram.RefreshImSkuFailure'),
            severity: 'error',
          });
        });
    }
  };

  return (
    <>
      <DrawerWrapper
        disableSave={inputValue.length <= 2}
        exception={true}
        handleClose={props.handleClose}
        headerText={useGetHeaderText(rowData)}
        onSaveClick={onSaveClick}
        subHeaderText={translate('Common.TrackingNumber', {
          value: rowData.dd_tracking,
        })}
      >
        <Stack
          overflow="auto"
          paddingLeft={2.25}
          paddingRight={3}
          paddingTop={1.5}
          spacing={1.5}
        >
          <Stack spacing={3}>
            <FormGroup>
              <Typography variant="body2">
                {translate('ExceptionDeals.IMSKU')}
                <span style={{ color: theme.palette.error.main }}>{` *`}</span>
              </Typography>
              <Stack alignItems="center" direction="row" spacing={1}>
                <Stack flex={1}>
                  <SearchBarComp
                    autoCompleteDataTestId="gds-vp-ed-edit-imsku-autocomplete"
                    defaultValue={inputValue}
                    exception={true}
                    getOptionLabel={getOptionLabel}
                    onInputChange={(value: string) =>
                      setInputValue(value.toUpperCase())
                    }
                    onKeyDown={onSaveClick}
                    onOptionSelected={handleOnChange}
                    options={options}
                    placeHolder={translate('ExceptionDeals.IMSKUPlaceholder')}
                    renderOption={renderOption}
                    textFieldDataTestId="gds-vp-ed-edit-imsku-textfield"
                  />
                </Stack>
                <Tooltip title="Refresh">
                  <IconButton
                    data-testid="gds-vp-ed-refresh-sku"
                    onClick={handleRefreshImSku}
                  >
                    <SyncIcon
                      fontSize="small"
                      sx={{ color: theme.palette.primary.main }}
                    />
                  </IconButton>
                </Tooltip>
              </Stack>
            </FormGroup>
            {isRulesEngineEnabled === false && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={makeDefault}
                    data-testid="gds-vp-ed-edit-imsku-checkbox"
                    disabled={!inputValue}
                    onChange={(_, checked) => setMakeDefault(checked)}
                  />
                }
                label={translate('VendorDeals.ResellerMakeDefaultLabel')}
              />
            )}
          </Stack>
        </Stack>
        {openDeleteDialog && (
          <DialogComponent
            checkBoxMessage={translate('ExceptionDeals.DeleteIMSKUCheckBox')}
            handleClose={() => {
              setOpenDeleteDialog(false);
              setDeleteSkuRequest({ imSku: '', skSboProductset: 0 });
              setChecked(false);
            }}
            message={translate('ExceptionDeals.DeleteIMSKUMessage')}
            onSubmit={() => deleteImSku.mutate()}
            requiredNotes={false}
            setChecked={setChecked}
            submitName={translate('Common.Delete')}
            title={translate('ExceptionDeals.DeleteIMSKUTitle')}
            warning={checked}
          />
        )}
      </DrawerWrapper>
      {!!defaultWarning && (
        <DefaultDialog
          defaultWarning={defaultWarning}
          handleOverrideDefaultConfirmation={handleOverrideDefaultConfirmation}
          keyName={'SKU'}
          keyValue={inputValue}
        />
      )}
    </>
  );
}
